(() => {
  'use strict';

  // v4.3 compatibility bridge: legacy v3 cart normalization is intentionally disabled.
  // The v4.1 controller remains the single owner of PICCOLINOOS normalization.
  window.ModaleenPiccolinoosLegacyV3Disabled = true;

  const PIC_HANDLES = new Set([
    'piccolinoos',
    'piccolinoos-mehrfachset',
    'piccolinoos-mengenpreis',
    'piccolinoos-mehrfachset-v2-intern',
    'piccolinoos-mengenpreis-v2-intern'
  ]);

  const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  function domHasPiccolinoos() {
    return Boolean(document.querySelector([
      '.cart-item[data-md-piccolinoos="true"]',
      '.cart-item[data-product-handle="piccolinoos"]',
      '.cart-item[data-product-handle="piccolinoos-mehrfachset"]',
      '.cart-item[data-product-handle="piccolinoos-mengenpreis"]',
      '.cart-item[data-product-handle="piccolinoos-mehrfachset-v2-intern"]',
      '.cart-item[data-product-handle="piccolinoos-mengenpreis-v2-intern"]'
    ].join(',')));
  }

  function setButtonBusy(button, busy) {
    if (!button) return;
    if (busy) {
      if (!button.hasAttribute('data-md-checkout-original-html')) {
        button.setAttribute('data-md-checkout-original-html', button.innerHTML);
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      const text = button.querySelector('.btn__text');
      const busyHtml = '<span class="md-checkout-spinner" aria-hidden="true"></span><span>Bestellung wird geprüft …</span>';
      if (text) text.innerHTML = busyHtml;
      else button.innerHTML = busyHtml;
      return;
    }

    const original = button.getAttribute('data-md-checkout-original-html');
    if (original !== null) {
      button.innerHTML = original;
      button.removeAttribute('data-md-checkout-original-html');
    }
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }

  function resetCheckoutState() {
    document.querySelectorAll('[data-md-checkout-v42]').forEach((button) => {
      button.dataset.mdCheckoutInFlight = 'false';
      setButtonBusy(button, false);
    });
    const controller = window.ModaleenPiccolinoosCartPricingV4;
    if (controller) controller.checkoutInFlight = false;
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-store' }
    });
    if (!response.ok) throw new Error(`Cart read failed: ${response.status}`);
    return response.json();
  }

  function picLines(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).filter((item) => PIC_HANDLES.has(String(item.handle || '')));
  }

  function bundleSizeFromSku(sku) {
    const match = String(sku || '').match(/^PIC-B([23])-([A-Z]{2})(?:-([A-Z]{2}))?(?:-([A-Z]{2}))?$/);
    if (!match) return 0;
    const size = Number(match[1]);
    const codes = [match[2], match[3], match[4]].filter(Boolean);
    return codes.length === size ? size : 0;
  }

  function isBasicCanonical(cart) {
    const lines = picLines(cart);
    if (!lines.length) return true;

    let total = 0;
    for (const line of lines) {
      const handle = String(line.handle || '');
      const qty = Math.max(0, Number(line.quantity || 0));
      if (!qty) return false;

      if (handle === 'piccolinoos') total += qty;
      else if (handle === 'piccolinoos-mehrfachset-v2-intern') {
        const size = bundleSizeFromSku(line.sku);
        if (!size) return false;
        total += size * qty;
      } else if (handle === 'piccolinoos-mengenpreis-v2-intern') total += qty;
      else if (handle === 'piccolinoos-mehrfachset') {
        const id = Number(line.variant_id || line.id || 0);
        if (id === 57383667073399) total += 2 * qty;
        else if (id === 57383667106167) total += 3 * qty;
        else return false;
      } else if (handle === 'piccolinoos-mengenpreis') total += qty;
      else return false;
    }

    if (total === 1) {
      return lines.length === 1 && lines[0].handle === 'piccolinoos' && Number(lines[0].quantity) === 1;
    }
    if (total === 2 || total === 3) {
      return lines.length === 1 &&
        lines[0].handle === 'piccolinoos-mehrfachset-v2-intern' &&
        Number(lines[0].quantity) === 1 &&
        bundleSizeFromSku(lines[0].sku) === total;
    }
    if (total >= 4) {
      return lines.every((line) => line.handle === 'piccolinoos-mengenpreis-v2-intern' && Number(line.quantity) > 0);
    }
    return false;
  }

  async function waitForPricingIdle(controller, timeoutMs = 7000) {
    const deadline = Date.now() + timeoutMs;
    let lastQueue = null;

    while (Date.now() < deadline) {
      const queue = controller.queue;
      if (queue && queue !== lastQueue) {
        lastQueue = queue;
        await queue;
      }
      if (!controller.timer && !controller.normalizePending && controller.queue === queue) return;
      await sleep(60);
    }
    throw new Error('PICCOLINOOS cart normalization timed out');
  }

  async function requestNormalization(controller, cart) {
    if (!window.jQuery) throw new Error('Cart normalization event is unavailable');
    window.jQuery('body').trigger('ajaxCart.afterCartLoad', [cart]);
    await waitForPricingIdle(controller, 7000);
  }

  function nativeCheckout(button) {
    const form = button.closest('form');
    if (!form) {
      window.location.assign('/checkout');
      return;
    }
    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.name = 'checkout';
    submit.value = '1';
    submit.hidden = true;
    form.appendChild(submit);
    submit.click();
    window.setTimeout(() => submit.remove(), 1000);
  }

  async function guardedCheckout(button) {
    if (button.dataset.mdCheckoutInFlight === 'true') return;
    button.dataset.mdCheckoutInFlight = 'true';
    setButtonBusy(button, true);

    try {
      const controller = window.ModaleenPiccolinoosCartPricingV4;
      if (!controller) throw new Error('PICCOLINOOS safety controller is unavailable');

      await waitForPricingIdle(controller, 7000);
      if (controller.unsafe) throw new Error('PICCOLINOOS cart is marked unsafe');

      let cart = await getCart();
      if (!picLines(cart).length) {
        setButtonBusy(button, false);
        button.dataset.mdCheckoutInFlight = 'false';
        nativeCheckout(button);
        return;
      }

      // Fast path: the normalizer is idle and the fresh server cart is already canonical.
      if (!isBasicCanonical(cart)) {
        await requestNormalization(controller, cart);
        if (controller.unsafe) throw new Error('PICCOLINOOS cart repair failed');
        cart = await getCart();
        if (!isBasicCanonical(cart)) throw new Error('PICCOLINOOS cart failed final canonical check');
      }

      window.location.assign('/checkout');
      window.setTimeout(() => {
        if (document.visibilityState === 'visible') resetCheckoutState();
      }, 8000);
    } catch (error) {
      console.error('[Modaleen PICCOLINOOS checkout bridge v4.3]', error);
      button.dataset.mdCheckoutInFlight = 'false';
      setButtonBusy(button, false);
      window.alert('Die PICCOLINOOS-Auswahl konnte vor dem Checkout nicht sicher geprüft werden. Bitte versuche es erneut.');
    }
  }

  function stopCompatEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function locateCartRow(lineNo, handle) {
    return Array.from(document.querySelectorAll('.cart-item[data-line]')).find((row) =>
      row.getAttribute('data-line') === lineNo && row.getAttribute('data-product-handle') === handle
    ) || null;
  }

  async function replayLegacyQuantity(row, direction, desiredValue) {
    try {
      const controller = window.ModaleenPiccolinoosCartPricingV4;
      if (!controller) throw new Error('PICCOLINOOS safety controller is unavailable');
      const lineNo = row.getAttribute('data-line');
      const handle = row.getAttribute('data-product-handle');
      await waitForPricingIdle(controller, 7000);
      const currentRow = locateCartRow(lineNo, handle);
      if (!currentRow || currentRow.getAttribute('data-md-piccolinoos') !== 'true') return;

      if (desiredValue !== undefined) {
        const input = currentRow.querySelector('.qty-input');
        if (!input) return;
        input.value = String(desiredValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const selector = direction === 'plus' ? '.qty-plus' : '.qty-minus';
      const button = currentRow.querySelector(selector);
      if (button) button.click();
    } catch (error) {
      console.error('[Modaleen PICCOLINOOS quantity bridge v4.3]', error);
    }
  }

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest && event.target.closest('[data-md-checkout-v42]');
    if (checkoutButton) {
      stopCompatEvent(event);
      if (!domHasPiccolinoos()) {
        nativeCheckout(checkoutButton);
        return;
      }
      guardedCheckout(checkoutButton);
      return;
    }

    const removeButton = event.target.closest && event.target.closest('.cart-item [data-pc-remove]');
    if (removeButton) {
      const row = removeButton.closest('.cart-item');
      stopCompatEvent(event);
      replayLegacyQuantity(row, null, 0);
      return;
    }

    const legacyQtyButton = event.target.closest && event.target.closest('.pc-tier-qty .qty-adjust');
    if (!legacyQtyButton) return;
    const row = legacyQtyButton.closest('.cart-item');
    if (!row || row.getAttribute('data-md-piccolinoos') === 'true') return;
    stopCompatEvent(event);
    replayLegacyQuantity(row, legacyQtyButton.classList.contains('qty-plus') ? 'plus' : 'minus');
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('.pc-tier-qty .qty-input');
    if (!input) return;
    const row = input.closest('.cart-item');
    if (!row || row.getAttribute('data-md-piccolinoos') === 'true') return;
    stopCompatEvent(event);
    replayLegacyQuantity(row, null, input.value);
  }, true);

  window.addEventListener('pageshow', resetCheckoutState);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resetCheckoutState();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetCheckoutState, { once: true });
  } else {
    resetCheckoutState();
  }
})();
